import { InkStorage, isSamePage } from "../../common";
import { drawPath } from "../../common";
import { rgb } from 'pdf-lib';
import { IBrushType } from "../../common";
import { MappingStorage } from "../../common";
import { StrokeStatus } from "../../common";
function stringToRgb(str) {
    // const rgbStrArr = stroke.color.match(/\d+/g);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(str);
    let r = 0, g = 0, b = 0;
    if (result) {
        r = parseInt(result[1], 16);
        g = parseInt(result[2], 16);
        b = parseInt(result[3], 16);
    }
    return { r, g, b };
}
export function addStrokesOnPage(pdfDoc, sobps, surfaceOwnerIds, externalStrokes) {
    const is = InkStorage.getInstance();
    const msi = MappingStorage.getInstance();
    const pages = pdfDoc.getPages();
    for (let i = 0, ln = sobps.length; i < ln; i++) {
        const sobp = sobps[i];
        const strokes = is.getPageStrokes(sobp);
        if (externalStrokes) {
            for (const externalStroke of externalStrokes) {
                if (isSamePage(sobp, externalStroke)) {
                    strokes.push(externalStroke);
                }
            }
        }
        if (strokes.length === 0)
            continue;
        const page = pages[i];
        const pageHeight = page.getHeight();
        const inkPageItem = msi.findPdfPage(sobp);
        const homography = inkPageItem === null || inkPageItem === void 0 ? void 0 : inkPageItem.pageMapping.h;
        for (let j = 0, stroke_ln = strokes.length; j < stroke_ln; j++) {
            const stroke = strokes[j];
            const sid = stroke.surfaceOwnerId;
            if (surfaceOwnerIds && sid && !surfaceOwnerIds.includes(sid)) {
                continue;
            }
            const { status, thickness, brushType, dotArray: da, color } = stroke;
            if (status === StrokeStatus.ERASED) {
                continue;
            }
            // const rgbStrArr = stroke.color.match(/\d+/g);
            const rrggbb = stringToRgb(color);
            // const { a, b, c, d, e, f, g, h } = homography;
            const { a: a0, b: b0, c: c0, d: d0, e: e0, f: f0, g: g0, h: h0 } = homography;
            let opacity = 1;
            if (brushType === IBrushType.MARKER) {
                opacity = 0.3;
            }
            // if (stroke.status === StrokeStatus.ERASED) {
            //   rrggbb = { r: 0, g: 255, b: 0 };
            //   opacity = 0.3;
            // }
            const pointArray = [];
            for (let k = 0, len_k = da.length; k < len_k; k++) {
                const dot = da[k];
                const nom = g0 * dot.x + h0 * dot.y + 1;
                const px = (a0 * dot.x + b0 * dot.y + c0) / nom;
                const py = (d0 * dot.x + e0 * dot.y + f0) / nom;
                const pdf_xy = { x: px, y: py };
                pointArray.push({ x: pdf_xy.x, y: pdf_xy.y, f: dot.f });
            }
            // page.setRotation(degrees(gridaPageObj.rotation));
            let strokeThickness = thickness * 4;
            switch (brushType) {
                case IBrushType.MARKER:
                    strokeThickness *= 5;
                    break;
                default: break;
            }
            const pathData = drawPath(pointArray, strokeThickness);
            page.moveTo(0, pageHeight);
            page.drawSvgPath(pathData, {
                color: rgb(rrggbb.r / 255, rrggbb.g / 255, rrggbb.b / 255),
                opacity: opacity,
                scale: 1,
            });
        }
    }
}
//# sourceMappingURL=addStrokesOnPage.js.map